import React from 'react';
import styled from 'styled-components';
import { HeaderAppBar } from '../../components/HeaderAppBar/HeaderAppBar';
import { Link } from 'react-router-dom';
import { Footer } from '../../components/Footer/Footer';
import { Container } from '@material-ui/core';
import { Unplugged } from './Unplugged';
import { useStyles } from '../AppStore/css';

interface ErrorPageProps {
    statusCode: number;
    message: string;
}

const ErrorPageStyled = styled.div`
    padding: 140px 0;
    text-align: center;

    h1,
    h3,
    p {
        user-select: none;
    }

    h1 {
        margin-bottom: 0;
        font-size: 90px;
        font-weight: 300;
        color: #1d57c7;
    }

    h3,
    p {
        font-size: 24px;
    }

    svg {
        position: relative;
        left: -130px;
        display: inline-block;
        margin-bottom: -220px;
    }
`;

const ErrorPageLinks = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 20px;
    font-weight: 300;

    > * {
        margin: 16px;
    }

    a {
        color: #1d57c7;
    }
`;

const getTitleForStatusCode = (statusCode: number) => {
    switch (statusCode) {
        case 404:
            return 'Not found';
        default:
            return 'Error';
    }
};

export const ErrorPage = ({ statusCode, message }: ErrorPageProps): JSX.Element => {
    const classes = useStyles();

    return (
        <div className={classes.root}>
            <HeaderAppBar />
            <main>
                <Container>
                    <ErrorPageStyled>
                        <Unplugged />
                        <h1>{statusCode}</h1>
                        <h3>{getTitleForStatusCode(statusCode)}</h3>
                        <p>{message}</p>
                        <ErrorPageLinks>
                            <div>
                                Go to the <Link to={'/'}>Homepage</Link>
                            </div>
                            <div>
                                Go to the{' '}
                                <a
                                    href={'https://docs.bokun.io'}
                                    target={'_blank'}
                                    rel={'noreferrer'}
                                >
                                    Bókun Help Center
                                </a>
                            </div>
                        </ErrorPageLinks>
                    </ErrorPageStyled>
                </Container>
            </main>
            <Footer />
        </div>
    );
};
